import { mapGetters } from 'vuex';

export default ({
  computed: {
    ...mapGetters({
      order: 'cart/order',
    }),
    userAuthenticated() {
      return this.order !== null && this.order.user_id !== null;
    },
  },
});
